import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";
import type { ZodType } from "zod";

type PayRequestId = Branded<string, "PayRequestId">;
const payRequestIdPrefix = "pay_request__";
const payRequestId: {
    zodSchema: ZodType<PayRequestId>;
    factory: () => PayRequestId;
    assert: (id: unknown) => id is PayRequestId;
} = genericId<PayRequestId>(payRequestIdPrefix);
const {
    factory: payRequestIdFactory,
    assert: isPayRequestId,
    zodSchema: payRequestIdZodSchema,
} = payRequestId;

export {
    isPayRequestId,
    payRequestId,
    payRequestIdFactory,
    payRequestIdPrefix,
    payRequestIdZodSchema,
};
export type { PayRequestId };
